import { useFormField as e } from "../FormField/useFormField.js";
import { FormField as t } from "../FormField/FormField.js";
import { InputBox as n } from "./InputBox.js";
import "react";
import { jsx as r } from "react/jsx-runtime";
//#region lib/components/Input/Input.tsx
function i({ label: i, helpText: a, errorMessage: o, prefix: s, suffix: c, id: l, containerProps: u, ...d }) {
	let { fieldId: f, hasError: p, describedBy: m } = e({
		id: l,
		helpText: a,
		errorMessage: o
	});
	return /* @__PURE__ */ r(t, {
		id: f,
		label: i,
		helpText: a,
		errorMessage: o,
		containerProps: u,
		children: /* @__PURE__ */ r(n, {
			id: f,
			hasError: p,
			prefix: s,
			suffix: c,
			"aria-invalid": p || void 0,
			"aria-describedby": m,
			...d
		})
	});
}
//#endregion
export { i as Input };
